import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { storeReferralCode } from "@/lib/referralCode";

export const ReferralCapturePage = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) storeReferralCode(code);
    navigate(ROUTES.register, { replace: true });
  }, [code, navigate]);

  return null;
};
